import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
    denominacion: Yup.string(),
    capacidad: Yup.string().typeError("La capacidad debe ser un número"),
})

export default validationSchema